import React, { ReactNode } from 'react';
import HelpIcon from '@mui/icons-material/HelpOutlineOutlined';
import { Box, Divider, Paper, SxProps, Theme, Typography } from '@mui/material';

import { TooltipIconButton } from '@paragon/client-tools';

interface Props {
  readonly title?: string | ReactNode;
  readonly titleButton?: ReactNode;
  readonly subtitle?: string;
  readonly sx?: SxProps<Theme>;
  readonly elevation?: number;
  readonly helper?: string;
  readonly children: ReactNode;
}

export function PropertiesPanel({ title, titleButton, subtitle, children, helper, sx, elevation }: Props) {
  return (
    <>
      {title && (
        <Box sx={{ marginTop: 2 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 2,
            }}
          >
            <Box
              sx={{
                width: '100%',
                display: 'grid',
                gridTemplateColumns: '1fr auto 1fr',
                columnGap: 1,
                alignItems: 'center',
                '&>:nth-child(1)': { gridColumnStart: 2 },
                '&>:last-child': { marginLeft: 'auto' },
              }}
            >
              <Typography variant="h6">{title}</Typography>
              {titleButton}
            </Box>

            {subtitle && <Typography align="center">{subtitle}</Typography>}
            {helper && (
              <TooltipIconButton title={helper}>
                <HelpIcon />
              </TooltipIconButton>
            )}
          </Box>
          <Divider />
        </Box>
      )}
      <Paper
        elevation={elevation ?? 0}
        sx={[
          {
            display: 'flex',
            flexDirection: 'column',
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        {children}
      </Paper>
    </>
  );
}
